import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { withTranslation } from "react-i18next";

function AddGroupDialog({ show, groupName, onGroupNameChange, onAdd, onClose, t }) {
    if (!show) return null;

    return (
        <Dialog
            title={t("header.buttons.add_group")}
            onClose={onClose}
            width={400}
        >
            <fieldset className="h-100">
                <form onSubmit={(e) => { e.preventDefault(); onAdd(); }} className="d-flex flex-column h-100">
                    <div>
                        <div className="form-label d-inline-block">
                            {t("group.add_group_label")}
                        </div>
                        <input
                            type="text"
                            maxLength={64}
                            className="form-control name-text"
                            autoFocus={true}
                            value={groupName}
                            onChange={(e) => onGroupNameChange(e.target.value)}
                            placeholder={t("group.add_group_placeholder")}
                            onKeyDown={(e) => e.key === "Enter" && onAdd()}
                        />
                    </div>
                    <DialogActionsBar layout="end">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                        >
                            {t("group.cancel_button")}
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={onAdd}
                            disabled={!groupName?.trim()}
                        >
                            {t("group.add_button")}
                        </button>
                    </DialogActionsBar>
                </form>
            </fieldset>
        </Dialog>
    );
}

export default withTranslation("attribute/common")(AddGroupDialog);
